import React from "react";
import * as Tooltip from "@radix-ui/react-tooltip";
import { stripInvalidPropsForElement } from "../../../utils/component-props";
import classNames from "classnames/bind";
import styles from "./InvalidInputMessageTooltip.module.scss";
import { Icon } from "../../../Icon";
import { Skeleton } from "../../../Skeleton";
import type { InvalidInputMessageTooltipProps } from "./types";

const cx = classNames.bind(styles);

export const InvalidInputMessageTooltip = ({
  children,
  intent = "error",
  iconProps,
  tooltipContentProps,
  isDisabled = false,
  isLoading = false,
  isBusy = false,
  ...restProps
}: InvalidInputMessageTooltipProps) => {
  return (
    <Tooltip.Provider delayDuration={100}>
      <Tooltip.Root>
        <Tooltip.Trigger
          {...stripInvalidPropsForElement(restProps, "button")}
          className={cx("tooltip-trigger", intent, restProps?.className)}
          type="button"
          disabled={isDisabled}
          aria-disabled={isDisabled}
        >
          <Icon
            variant={intent === "error" ? "warning-octagon" : "warning"}
            weight="bold"
            size={16}
            {...iconProps}
            data-testid="invalid-input-message-tooltip-trigger"
          />
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            sideOffset={8}
            {...tooltipContentProps}
            className={cx(
              "tooltip-content",
              intent,
              tooltipContentProps?.className
            )}
            aria-live="polite"
            role="alert"
          >
            <Skeleton
              isLoading={isLoading}
              isBusy={isBusy}
            >
              {children}
            </Skeleton>
            <Tooltip.Arrow className={cx("tooltip-arrow", intent)} />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
